// extracted by mini-css-extract-plugin
module.exports = {"pagination-button-previous":"styles_pagination-button-previous__2zW70"};